import type { ReactNode } from "react";

/** Раздел настроек: заголовок, пояснение и содержимое. */
export function Section({ title, hint, children }: { title: string; hint?: string; children: ReactNode }) {
  return (
    <section className="mb-7">
      <h3 className="text-[15px] font-semibold">{title}</h3>
      {hint && <p className="mt-1 text-[13px] leading-[18px] text-sub">{hint}</p>}
      <div className="mt-3">{children}</div>
    </section>
  );
}
